import { Subject } from 'rxjs/Subject';
import merge from 'lodash/merge';


export class AppState {
    constructor(window, document) {
        this.raw_data = {};
        let contexts = document.querySelectorAll('script[type="application/json+context"]');
        for (let i = 0; i < contexts.length; i++) {
            let obj = JSON.parse(contexts[i].textContent);
            this.raw_data = merge(this.raw_data, obj);
        }
    }

    getState() {
        // automatically assign all keys from raw data to current object
        Object.keys(this.raw_data).map(k => {
            (this)[k] = this.raw_data[k]; // This is ugly Flow workaround for `this[k] = <smth>`
        });

        return this;
    }
}

// console polyfill
window.console = window.console || {
    log: function () {}
};

const appBus = new Subject();

export function getAppBus() {
    return appBus;
}
